import { DeviceUtils } from "@/utils";

export default {
  data() {
    return {
      isMobileValue: null,
      isTabletValue: null,
      isDesktopValue: null,
    };
  },
  created() {
    if (global.isClientSide) {
      this.changeDeviceData();
      window.addEventListener("resize", () => {
        this.changeDeviceData();
      });
    }
  },
  methods: {
    changeDeviceData() {
      this.isMobileValue = DeviceUtils.isMobile();
      this.isTabletValue = DeviceUtils.isTablet();
      this.isDesktopValue = DeviceUtils.isDesktop();

      this.$store?.dispatch("update_device_info", {
        isMobileX: this.isMobileValue,
        isTabletX: this.isTabletValue,
        isDesktopX: this.isDesktopValue,
      });
    },
  },
};
